export * from "./AcademyDetailsTemplate";
export * from "./AcademyTemplate";
